export default __webpack_public_path__ + "static/media/spacecadet.11963773.png";